
export enum ViewOptionStateEnum {
  Default = 0,
  Hidden = 1,
  Disabled = 2,
  Changed = 3
}
